import script from "./Breadcrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&setup=true&lang=js"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=19bf618c&scoped=true&lang=scss"

import exportComponent from "/home/production/domains/architect.youniversity.be/public_html/architect/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19bf618c"]])

export default __exports__